import { appLangLink } from '@bcf2-v1-ui-routes/app-lang-link';
import { msg } from '@lit/localize';
import type { FooterLinksConfig } from '../types';

export const footerLinks = (): FooterLinksConfig => [
  {
    title: msg('General info'),
    links: [
      {
        label: msg('Terms and Conditions'),
        url: appLangLink('/sp/terms-and-conditions/')
      },
      {
        label: msg('Bonus terms'),
        url: appLangLink('/sp/bonus-terms/')
      },
      {
        label: msg('Privacy policy'),
        url: appLangLink('/sp/privacy-policy/')
      },
      {
        label: msg('Responsible gambling'),
        url: appLangLink('/sp/responsible-gaming/')
      },
      {
        label: msg('Refund policy'),
        url: appLangLink('/sp/refund-policy/')
      },
      {
        label: msg('Affiliate program'),
        url: 'https://click2.partners/'
      },
      {
        label: msg('Support'),
        url: appLangLink('/support/')
      },
      {
        label: msg('Sitemap'),
        url: appLangLink('/sp/sitemap/')
      }
    ]
  },
  {
    title: msg('Promotions'),
    links: [
      {
        label: msg('All Promotions'),
        url: appLangLink('/promotions/')
      },
      {
        label: msg('Tournaments'),
        url: appLangLink('/tournaments/')
      }
    ]
  },
  {
    title: msg('Casino'),
    links: [
      {
        label: msg('New Games'),
        url: appLangLink('/collection/new-games/')
      },
      {
        label: msg('Best Slots'),
        url: appLangLink('/collection/best-slots/')
      },
      {
        label: msg('Jackpot Slots'),
        url: appLangLink('/jackpot-slots/')
      },
      {
        label: msg('Megaways Slots'),
        url: appLangLink('/collection/megaways/')
      },
      {
        label: msg('Fruits Slots'),
        url: appLangLink('/collection/fruits-slots/')
      },
      {
        label: msg('Bonus Buy Slots'),
        url: appLangLink('/collection/bonus-buy/')
      },
      {
        label: msg('Classic Slots'),
        url: appLangLink('/collection/classic-slots/')
      },
      {
        label: msg('High Volatility Slots'),
        url: appLangLink('/collection/high-volatility/')
      },
      {
        label: msg('Book Slots'),
        url: appLangLink('/collection/book-slots/')
      },
      {
        label: msg('Ancient Slots'),
        url: appLangLink('/collection/ancient-slots/')
      },
      {
        label: msg('Gold Slots'),
        url: appLangLink('/collection/gold-slots/')
      }
    ]
  },
  {
    title: msg('Live Casino'),
    links: [
      {
        label: msg('Best Live Casino'),
        url: appLangLink('/collection/best-live-casino/')
      },
      {
        label: msg('Trending Live Games'),
        url: appLangLink('/collection/trending-live-games/')
      },
      {
        label: msg('Live Shows'),
        url: appLangLink('/collection/live-shows/')
      },
      {
        label: msg('Live Roulette'),
        url: appLangLink('/collection/live-roulette/')
      },
      {
        label: msg('Live Blackjack'),
        url: appLangLink('/collection/live-blackjack/')
      },
      {
        label: msg('Live Baccarat'),
        url: appLangLink('/collection/live-baccarat/')
      }
    ]
  },
  {
    title: msg('Table Games'),
    links: [
      {
        label: msg('Table Games'),
        url: appLangLink('/table-games/')
      }
    ]
  },
  {
    title: msg('Jackpots'),
    links: [
      {
        label: msg('EGT Jackpot'),
        url: appLangLink('/collection/egt-jackpot/')
      }
    ]
  }
];

export { sportsbookFooterLinks } from './sportsbook-footer-links';
